var map = {
	"./berning.svg": "60f6",
	"./circle.svg": "41ae",
	"./dc.svg": "0d87",
	"./dp.svg": "b6f5",
	"./eleven.svg": "d07e",
	"./grafental.svg": "64ba",
	"./greenelements.svg": "771c",
	"./horizon.svg": "b8fd",
	"./jardindusoleil.svg": "9584",
	"./karinfehr.svg": "cdbb",
	"./kgn.png": "6e56",
	"./kgn_color.png": "de26",
	"./marekraminski.svg": "3da3",
	"./momeni.svg": "74fd",
	"./newport.svg": "0f28",
	"./newportluzern.svg": "f69f",
	"./oak.png": "c501",
	"./ralphhagedorn.svg": "fb1c",
	"./roofments.svg": "b2a0",
	"./sassenscheidt.svg": "9963",
	"./schwarzbachquartier.svg": "2cf6",
	"./thecurve.svg": "86fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0c25";